import React, {  useState } from "react";
import ArrowUpIcon from "../icons/ArrowUpIcon";
import { JobsDataType } from "../../types/api-response";
import { folderPagePath, formatDate } from "../../utils";
import { useLazyDownloadExcelQuery } from "../../redux/apis/manageJobPostingHooks";
import { getUserDetails } from "../../utils/getUserDetails";
import AdditionalContent from "./AdditionalContent";
import SuccessCheckIcon from "../icons/SuccessCheckIcon";
import DownloadXls from "../../resources/images/icons/DownloadXls";
import CopyIcon from "../../resources/images/icons/CopyIcon";
import getMappedJobType from "../common/utils/getMappedJobType";
import CommonEmptyState from "./CommonEmptyState";
import CustomCheckbox from "../common/CustomCheckbox";
import { selectAllCallBack } from "./selectAllCallback";
import DownloadXlsModal from "../mjpModals/DownloadXlsModal";
import { useAppSelector } from "../../redux/store";
import { JOB_TITLE_CHAR_LIMIT_ELLIPSIS } from "../../constants/tabs";
import { PASSIVE_JOB } from "../../constants/Filters";
import {Questionnaire} from "@foundit/questionnaire/dist/Questionnaire"
import "../../../node_modules/@foundit/questionnaire/dist/Questionnaire.css";
import { MIDDLEWARE } from "../../constants/api";
import FolderName from "./FolderName";

interface Props {
  jobsData: JobsDataType[] | undefined;
  onDClick?: Function;
  checkedData: JobsDataType[];
  setCheckedData: Function;
  triggerInventory:Function;
}

const Expired = ({ jobsData ,onDClick=()=>{},  checkedData, setCheckedData,triggerInventory}: Props) => {
  const [clickedRow, setClickedRow] = useState<number | null>(null);
  const [infocus, setInfocus] = useState<number | null>(null);
  const [openQuestionnaire, setOpenQuestionnaire] = useState<boolean>(false);
  const [currentJobId, setCurrentJobId] = useState<Number | null>(null);
  const [selectedRowData, setSelectedRowData] = useState<
    JobsDataType[] | null
  >();
  const openModal: any = useAppSelector((state:any)=>state?.download?.openModal)

  const [downloadExcel, {}] = useLazyDownloadExcelQuery();
  const userDetails = getUserDetails();


  const handleEllipsesClick = (item: number) => {
    setClickedRow((prevClickedRow) => (prevClickedRow === item ? null : item));
  };

  const handleDownloadExcel = (jobId: number,e:React.MouseEvent) => {
    onDClick(jobId,e)
  };

  if ((jobsData || []).length === 0) {
    return <CommonEmptyState text="You have no expired jobs!"/>;
  }

  return (
    <>
    <Questionnaire 
      platform={"MJP"} 
      questionnaireId={currentJobId} 
      middleware={MIDDLEWARE} 
      showSideBar={openQuestionnaire} 
      setShowSideBar={setOpenQuestionnaire}
      isExpired={true}
    />
    
    <div className="search-result_container">
      {(jobsData || []).map((job, index) => {
        const {
          jobId,
          title,
          jobType,
          hasScreening,
          postedDate,
          renewalDate,
          recruiterName,
          location,
          folderName,
          views,
          applicationCount,
          applicationCountUnread,
          recommended,
          jobPostingType,
          updateDate,
          jobFrom,
          inbound
        } = job || {};

        const isRenewed = Number(renewalDate?.length) > 0;

        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div key={String(jobId)}  className={`search-result_card${infocus==jobId ? ' infocus': ''}`}>
            <div className="search-result_card_lt">
                <CustomCheckbox
                  checkboxData={{
                    label: "",
                    id: "card_" + String(jobId),
                    callBack: () =>
                      selectAllCallBack({ job, checkedData, setCheckedData }),
                  }}
                  checked={checkedData
                    ?.map((data) => data?.jobId)
                    ?.includes(jobId)}
                />
              </div>

              <div className="search-result_card_rt_check">
                <div className="search-result_title-container">
                  <div className="search-result_card_row">
                    <span
                      className={`main_title clickable${title?.length > JOB_TITLE_CHAR_LIMIT_ELLIPSIS ? " allow_ellipsis":""}`}
                      role="button"
                      onClick={() =>
                        window.open(
                         `${window.location.origin}/edge/${folderPagePath}?folderID=${jobId}&autoMatch=false${jobFrom && jobFrom === PASSIVE_JOB ? '&tab=inbound':''}&jobLinked=true`,
                          "_blank"
                        )
                      }
                    >
                      {title}
                    </span>
                    <span className="faded subtitle">
                      ({`${jobPostingType=='SJS' ? getMappedJobType('SOCIAL') : getMappedJobType(jobType?.name)}`})
                    </span>
                    {jobFrom === PASSIVE_JOB ? <span className="inboundTag">Inbound Jobs</span> : null}
                  </div>
                  
                  {jobFrom !== PASSIVE_JOB && <>{(!inbound) && hasScreening ? (
                    <button
                      className="foundit-button secondaryButton small search-result_non-clickable-questionnaire"
                      style={{minWidth: "140px"}}
                      onClick={() =>{
                        setCurrentJobId(jobId);
                        setOpenQuestionnaire(true);
                      }
                      }
                    >
                      <span className="flex-center">
                        <span style={{ marginRight: "4px"}}>
                          Questionnaire
                        </span>
                        <SuccessCheckIcon />
                      </span>
                    </button>
                  ) : null}</>}
                </div>

                <div className="list_title_container">
                  <div
                    style={{
                      display: "flex",
                      fontSize: "12px",
                      margin: "6px 0",
                      lineHeight: "20px",
                    }}
                  >
                    <div className='mjp_label_container'> 
                      <span className='faded mjp_label'>Posted on: </span> 
                      <span className="mjp_value">{postedDate ? formatDate(postedDate) : '-'}</span>
                      </div>
                    <div className="vertical_line" />
                    {!isRenewed ? (postedDate == updateDate ? 
                     null :
                     <> 
                     <div className='mjp_label_container'>
                      <span className='faded mjp_label'>Edited on:</span> 
                      <span className="mjp_value">{updateDate ? formatDate(updateDate) : '-'}</span>
                     </div> 
                     <div className="vertical_line" />
                     </>) :
                     <>
                      <div className='mjp_label_container'>
                        <span className='faded mjp_label'>Renewed on:</span> 
                        <span className="mjp_value">{renewalDate ? formatDate(renewalDate) : '-'}</span>
                      </div> 
                      <div className="vertical_line" />
                      </>
                    }
                   

                    {jobFrom !== PASSIVE_JOB ? <>
                    <div className='mjp_label_container'>
                      <span className="faded mjp_label">Posted by: </span>
                      < span className="mjp_value">{recruiterName}</span>
                    </div>
                    <div className="vertical_line" />
                    </> : null}

                    <div className='mjp_label_container'>
                      <span className="faded mjp_label">Location: </span>
                      < span className="mjp_value">{location?.replace(/,(?!\s)/g, ', ') || ""}</span>
                    </div>
                  </div>
                </div>

                <div className="horizontal_seperator" />

                <div className="search-result_card_row">
                  <div className="folder_table_container">
                    <div className="folder_table_item">
                      <div className="folder_column faded">Folder</div>
                      <div className="main_title folder-name cp-cursor"
                        onClick={() =>
                          window.open(
                            `${window.location.origin}/edge/${folderPagePath}?folderID=${jobId}&autoMatch=false${jobFrom && jobFrom === PASSIVE_JOB ? '&tab=inbound':''}&jobLinked=true`,
                            "_blank"
                          )
                        }
                      >
                      <FolderName title={folderName}>
                      {folderName}
                      </FolderName>
                      </div>
                    </div>

                    <div className="folder_table_item">
                      <div className="folder_column faded">Views</div>
                      <div className="main_title">{views}</div>
                    </div>

                    <div className="folder_table_item">
                      <div className="folder_column faded">Applicants</div>
                      <div className="main_title">
                        {applicationCount}
                      </div>
                    </div>

                    {jobFrom !== PASSIVE_JOB && <div className="folder_table_item">
                      <div className="folder_column faded">Recommended</div>
                      <div className="main_title cp-cursor"
                      onClick={() =>
                        typeof recommended == 'number' &&
                        window.open(
                          `${window.location.origin}/edge/${folderPagePath}?folderID=${jobId}&tab=Recommended&autoMatch=true&jobLinked=true`,
                          "_blank"
                        )
                      }
                      >{typeof recommended == 'number' ? recommended : "-"}</div>
                    </div>}
                  </div>
                  <div className="search-result_flex">
                    <div
                      role="button"
                      className={"search-result_active-icons"+" "+(inbound ? "search-result_disabled" : "")}
                      title="Copy"
                      onClick={() =>
                        window.open(
                          // `${window.location.origin}/v4/jobposting/copy/${jobId}`,
                          `${window.location.origin}/edge/jobposting/new-job-posting/copy/${jobId}`,
                          "_blank"
                        )
                      }
                    >
                      <CopyIcon />
                    </div>
                    <div
                      role="button"
                      className={"search-result_active-icons"+" "+(inbound ? "search-result_disabled" : "")}
                      onClick={(e) => handleDownloadExcel(jobId,e)}
                    >
                      <DownloadXls />
                    </div>
                    <div
                      role="button"
                      className="search-result_active-icons"
                      onClick={() => {
                        if(infocus == null) {
                          setSelectedRowData([job]);
                          setInfocus(jobId)
                          handleEllipsesClick(jobId);
                        }
                      }}
                    >
                      <span className="menu-3-dots" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {clickedRow === jobId && (
              <AdditionalContent
                selectedRowData={selectedRowData}
                isExpire={true}
                setClickedRow={setClickedRow}
                callbackOnClose={() => setInfocus(null)}
              />
            )}
            
{!!openModal && sessionStorage.getItem("mjpKey") == jobId.toString()  &&
            <DownloadXlsModal
            // modalId={modalId}
            key={jobId+index}
            id={jobId}
            triggerInventory={triggerInventory}
            
            />
      }
          </div>
        );
      })}
    </div>
  </>
  );
};

export default React.memo(Expired);
